<template>
    <div class="user-table-container">
        <div class="HeaderTab">
             <el-button v-for="item in Child" :key="item.id" size="small" :type="SysType != item.id?'info':'primary'" plain @click="ToggleSysType(item.id)">{{item.system_name}}</el-button>
        </div>
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select class="Wid120" size="medium" v-model="TypeVal" @change="ReSetPage" clearable placeholder="申请类型">
                    <el-option v-for="i in RowType" :key="i.id" :label="i.group_name" :value="i.id"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="GroupVal" @change="ReSetPage" clearable placeholder="组别">
                    <el-option v-for="item in GroupList" :key="item.id" :label="item.group_name" :value="item.id"></el-option>
                </el-select>
                <el-select class="Wid120" size="medium" v-model="SortVal" @change="ReSetPage" clearable placeholder="排序">
                    <el-option label="平均分升序" value="asc"></el-option>
                    <el-option label="平均分降序" value="desc"></el-option>
                </el-select>
                <el-input class="Wid120" size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle v-if="SeleId.length>0" class="BgColor" size="small" type="warning" @click="DownAll">批量下载</el-button>
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading" :tree-props="{children: 'children'}" default-expand-all row-key="id" @selection-change="SeleChange">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="record_number" label="编号" min-width="50"></el-table-column>
            <el-table-column prop="group_name" label="申请类型" min-width="100"></el-table-column>
            <el-table-column prop="record_name" label="申请名称" min-width="100"></el-table-column>
            <el-table-column prop="user_name" label="申请人" min-width="80"></el-table-column>
            <el-table-column prop="admin_name" label="操作人" min-width="80"></el-table-column>
            <el-table-column prop="online_pingfen" label="初审平均分" min-width="60"></el-table-column>
            <el-table-column prop="final_pingfen" label="复审平均分" min-width="60"></el-table-column>
            <el-table-column label="加分项" min-width="120">
                <template slot-scope="scope" v-if="scope.row.jiafen_var">
                    <div>加分名称：{{scope.row.jiafen_name}}</div>
                    <div>加分值：{{scope.row.jiafen_var}}</div>
                    <div class="MaxHei20">描述：{{scope.row.jiafen_details}}</div>
                </template>
            </el-table-column>
            <el-table-column prop="sq_status_name" label="评审阶段" min-width="80">
                <template slot-scope="scope">
                    <el-tag size="small">{{scope.row.sq_status_name}}</el-tag>
                    <i class="NavIcon el-icon-view" v-if="scope.row.sq_status==11" @click="OpenMsg(scope.row.yuanyi)"></i>
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="提交时间" min-width="100"></el-table-column>
            <el-table-column label="操作" width="200" align="center">
                <template slot-scope="scope">
                    <el-tooltip effect="dark" content="评分明细" placement="top-start">
                        <i class="NavIcon el-icon-tickets" @click="LockPS(scope.row.id,'PF')"></i>                     
                    </el-tooltip>
                    <el-popover placement="top" width="100">
                        <div>
                            <div class="TongBuDis JusRight">
                                <el-button type="primary" plain size="mini" @click="LockUserPs(scope.row)">预览</el-button>
                            </div>
                            <div class="TongBuDis">
                                <span>形式审查意见</span> 
                                <el-switch v-model="scope.row.is_xingshi_user_yj" :active-value="1" :inactive-value="0" @change="ToggleTongBu(scope.row)" />
                            </div>
                            <div class="TongBuDis">
                                <span>资料/初审</span>
                                <el-switch v-model="scope.row.is_online_user_yj" :active-value="1" :inactive-value="0" @change="ToggleTongBu(scope.row)" />
                            </div>
                            <div class="TongBuDis">
                                <span>现场/复审</span>
                                <el-switch v-model="scope.row.is_final_user_yj" :active-value="1" :inactive-value="0" @change="ToggleTongBu(scope.row)" />
                            </div>
                            <div class="TongBuDis">
                                <span>点评意见</span>
                                <el-switch v-model="scope.row.is_dianping_user_yj" :active-value="1" :inactive-value="0" @chanDownFile="ToggleTongBu(scope.row)" />
                            </div>
                        </div>
                        <div slot="reference" class="TongBuBtn">
                          <el-tooltip effect="dark" content="意见同步用户" placement="top-start">
                              <i class="NavIcon el-icon-s-promotion"></i>
                          </el-tooltip>
                        </div>
                    </el-popover>
                    <el-tooltip effect="dark" content="评审人员查看" placement="top-start">
                        <i class="NavIcon iconfont icon-shenhe" @click="LockPS(scope.row.id,'PS')"></i>                     
                    </el-tooltip>
                    <!-- <el-tooltip effect="dark" content="数据对比" placement="top-start">
                        <i class="NavIcon iconfont el-icon-finished" @click="LockPS(scope.row.id,'DB')"></i>                     
                    </el-tooltip> -->
                    <el-tooltip effect="dark" content="收集信息查看" placement="top-start">
                        <i class="NavIcon el-icon-view" @click="LockData(scope.row)"></i>
                    </el-tooltip>
                    <el-tooltip effect="dark" content="下载" placement="top-start">
                        <i class="NavIcon el-icon-download" @click="DownFile(scope.row.id)"></i>
                    </el-tooltip>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol" hide-on-single-page>
        </el-pagination>
        <FieldMol :visible="NewData.NewBlon" :Type="'Lock'" :rowData="RowData" :newData="NewData" @cancel="$Tools.ResetData(NewData)"/>
        <PingShenInfo :visible="PSBlon" :Type="Type" :rowData="DeatailData" @cancel="PSBlon = false" />
        <PingShenUser :visible="UserPSBlon" :rowData="UserPSData" @cancel="UserPSBlon = false" />
    </div>
</template>

<script>
    export default {
        name: "AdminIndex",
        data() {
            return {
                loading:false,
                SysType:"",
                SearchVal:"",
                GroupVal:"",
                TypeVal:"",
                SortVal:"",
                GroupList:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'PS',
                SeleId:[],
                NewData:{
                    record_name:"",
                    NewBlon:false,
                },
                RowType:[],
                RowData:{
                    group: [],
                    gl_file: [],
                },
                DeatailData:{},//所有详情数据
                PSBlon:false,//评审人员查看
                UserPSData:{},//评审数据
                UserPSBlon:false,
            };
        },
        props: ['ApiType','Child'],
        mounted() {
            this.SysType = this.Child[0].id;
            this.GetData();
            this.GetGroup();
            this.GetTypeList();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/admin/complete/index',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    system_code:this.ApiType,
                    pingfenSort:this.SortVal,
                    group_id:this.TypeVal,
                    field_ids:this.GroupVal,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetTypeList(){
                this.$get('/admin/record/allData',{
                    SystemCode:this.ApiType,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    if(res){
                        this.RowType = res.data.list;
                    }
                })
            },
            GetGroup(){
                this.$get('/admin/expert_group/getAll').then(res=>{
                    if(res){
                        this.GroupList = res.data;
                    }
                })
            },
            GetDetail(id){
                this.$get('/admin/complete/detail',{
                    id:id,
                }).then(res=>{
                    if(res){
                        var Data = JSON.parse(JSON.stringify(res.data));
                        Data.group = Data.group.map(item=>{
                            if (item.field_options && typeof item.field_options === 'string') {
                                try {
                                    item.field_options = JSON.parse(item.field_options);
                                    if(item.field_type == 'checkbox'){item.default_value = item.default_value?item.default_value.split(","):[];}
                                } catch (e) {
                                    item.field_options = [];
                                }
                            }
                            return item;
                        })
                        Data.gl_file = Data.gl_file?Data.gl_file.split(","):[];
                        this.RowData = Data;
                        this.NewData.NewBlon = true;
                    }
                })
            },
            SeleChange(val){
                this.SeleId = val.map(item => item.id);
            },
            GetPSData(id){
                this.$get('/admin/complete/gradeinfo',{
                    id:id,
                }).then(res=>{
                    if(res){
                        this.PSBlon = true;
                        this.DeatailData = res.data;
                    }
                })
            },
            LockPS(id,t){
                this.Type = t;
                this.GetPSData(id)
            },
            LockData(row){
                this.NewData.record_name = row.record_name;
                this.GetDetail(row.id)
            },
            DownFile(id){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$get('/admin/complete/export',{
                        id:id,
                    }).then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    })
                } catch (error) {
                    loading.close();
                }
            },
            DownAll(){
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    this.$post('/admin/complete/plexport',{
                        ids:this.SeleId,
                        type:3,
                    }).then(res=>{
                        loading.close();
                        if(res){
                            window.open(res.data.download_url)
                        }
                    }).catch(error => {
                        loading.close();
                        console.error('导出接口错误：', error);
                    });
                } catch (error) {
                    loading.close();
                }
            },
            ToggleTongBu(row){
                this.$post('/admin/record/userkai',{
                    id:row.id,
                    is_xingshi_user_yj:row.is_xingshi_user_yj,
                    is_online_user_yj:row.is_online_user_yj,
                    is_final_user_yj:row.is_final_user_yj,
                    is_dianping_user_yj:row.is_dianping_user_yj,
                }).then(res=>{
                    if(res){
                        this.$message.success(res.msg);
                        this.GetData();
                    }
                })
            },
            LockUserPs(row){
                this.$get('/admin/record/shenhe',{
                    id:row.id,
                    system_code:this.ApiType,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    if(res){
                        this.UserPSBlon = true;
                        this.UserPSData = res.data;
                    }
                })
            },
            ToggleSysType(id){
                this.SysType = id;
                this.ReSetPage();
                this.GetTypeList();
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
            OpenMsg(msg){
                this.$alert(msg, '原因', {
                    confirmButtonText: '确定',
                    callback: action => {}
                });
            },
        }
    };
</script>

<style scoped>
    .MaxHei20{
        max-height: 50px;
        overflow-y: auto;
    }
    .MaxHei{
        max-height: 500px;
        overflow-y: auto;
    }
    .DisFlex{
        display: flex;
        align-items: center;
    }
    .FuJianPos{
        position: relative;
        padding: 6px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
    }
    .FuJianAbs{
        position: absolute;
        top: -5px;
        right: -15px;
        font-size: 14px;
        color: #d51938;
    }
    .TongBuDis{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
    }
    .JusRight{
        justify-content: flex-end;
    }
    .TongBuBtn{
        display: inline-block;
    }
</style>
